module.exports = __webpack_public_path__ + "img/icon-dashboard-modal.0af25447.svg";